import { GoogleLogout }  from "react-google-login";

const clientid = '425916914844-jd2m6rae8avaqt111e10lifcg0g0fp7v.apps.googleusercontent.com';

function Logout() {

  const onLogoutSuccess = (res) => {
    console.log("Logged out successfully", res);
  }

  return(
    <span id="SignOutButton">
      <GoogleLogout
        clientId={clientid}
        __client_id={clientid}
        buttonText="Logout"
        onLogoutSuccess={onLogoutSuccess}
      />
    </span>
  );
}

export default Logout;
